import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { FC } from 'react';

import { selectIsVpnDetected } from 'features/vpn-behavior/store';
import { useVpnDetection } from 'features/vpn-behavior/hooks';
import theme from 'features/theme/theme';
import { useAppSelector } from 'features/app/hooks';

/** Displays a warning banner when VPN is detected. Uses useVpnDetection to trigger detection check. */
export const VpnWarning: FC = () => {
  useVpnDetection();
  const isVpnDetected = useAppSelector(selectIsVpnDetected);
  const { t } = useTranslation('translation', {
    keyPrefix: 'vpnBehavior',
  });

  return (
    <div>
      {isVpnDetected && (
        <output className='vpn-warning'>
          <Typography
            variant='textLargeMedium'
            color={theme.palette.common.white}
            mb={4}
          >
            {t('vpnDetectedWarning')}
          </Typography>
        </output>
      )}
    </div>
  );
};
